import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import baseURL from '../Apiurs/Apiurls';
// import { AuthContext } from "../AuthContext/Authcontext";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from "../images/sbslogo.png"

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false); 
  // const { login } = useContext(AuthContext);

  useEffect(() => {
    localStorage.clear(); 
  }, []);

  //   const handleLogin = async (e) => {
  //     e.preventDefault();

  //     const userData = { email, password };
  //     console.log("Logging in with data:", userData); 

  //     try {
  //       const response = await fetch(`${baseURL}/api/login`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(userData),
  //       });

  //       const data = await response.json();
  //       console.log("Response from login API:", data); 

  //       if (response.status === 200) {
  //         login(
  //           data.token,
  //           data.id,
  //           data.name,
  //           data.mobile,
  //           data.email,
  //           data.role,
  //           data.assign_manager,
  //           data.managerId
  //         );

  //         if (data.role === 'employee') {
  //           navigate('/s-dashboard');
  //         } else if (data.role === 'manager') {
  //           navigate('/m-dashboard');
  //         } else {
  //           navigate('/a-dashboard');
  //         }
        
  //       } else {
  //         alert(data.message || "Login failed. Please check your credentials.");
  //       }
  //     } catch (err) {
  //       console.error('Login failed:', err);
  //       alert('Login failed');
  //     }
  //   };

  // 🔹 Static Login Handler
  const handleStaticLogin = (e) => {
    e.preventDefault();

    if (email === "admin@gmail.com" && password === "admin@123") {
      navigate('/products');  // Redirect on success
    } else {
      alert("Invalid credentials. Please try again!");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-image-side">
          <div className="login-logo-container">
            <img
              className="login-logo"
              src={logo}
              alt="Funstay Logo"
            />
          </div>
          <h2 className="login-tagline"></h2>
        </div>
        <div className="login-login-side">
          <div>
            <h1 className="login-welcomeback">Welcome Back</h1>
            <p className="login-subtitle">Log in to start your next adventure!</p>
          </div>
          <form onSubmit={handleStaticLogin}>
            <div className="login-input-group">
              <label className="login-label">Email</label>
              <input
                className="login-input"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
              />
            </div>
            <div className="login-input-group">
              <label className="login-label">Password</label>
              <div className="login-password-input-group">
                <input
                  className="login-input"
                  type={showPassword ? 'text' : 'password'} 
                  placeholder="********"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="login-password-toggle-button"
                  onClick={() => setShowPassword(!showPassword)} 
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <div className="d-flex justify-content-end mb-2">
              <a href="#" className="login-forgot-password"> Forgot Password</a>
            </div>
            <button 
              type="submit" 
              className="login-btn login-btn-login"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
